import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
import Editor from 'wangeditor';
import 'wangeditor/release/wangEditor.min.css';
import { oneOf } from '@/libs/tools';
import { upload_pic } from '@/api/xinli';
export default {
  name: 'Editor',
  props: {
    value: {
      type: String,
      default: ''
    },

    /**
     * 绑定的值的类型, enum: ['html', 'text']
     */
    valueType: {
      type: String,
      default: 'html',
      validator: function validator(val) {
        return oneOf(val, ['html', 'text']);
      }
    },

    /**
     * @description 设置change事件触发时间间隔
     */
    changeInterval: {
      type: Number,
      default: 200
    },

    /**
     * @description 是否开启本地存储
     */
    cache: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    editorId: function editorId() {
      return "editor".concat(this._uid);
    }
  },
  methods: {
    setHtml: function setHtml(val) {
      this.editor.txt.html(val);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.editor = new Editor("#".concat(_this.editorId));

      _this.editor.customConfig.customUploadImg = function (files, insert) {
        var formData = new FormData();
        formData.append('filename', files[0]);
        formData.append('type', 'expert_avatar');
        upload_pic(formData).then(function (res) {
          var result = res;

          if (result.result === 0) {
            var data = result.body.pic_url;
            insert(data);
          }
        });
      };

      _this.editor.customConfig.onchange = function (html) {
        var text = _this.editor.txt.text();

        if (_this.cache) localStorage.editorCache = html;

        _this.$emit('input', _this.valueType === 'html' ? html : text);

        _this.$emit('on-change', html, text);
      };

      _this.editor.customConfig.onchangeTimeout = _this.changeInterval; // create这个方法一定要在所有配置项之后调用

      _this.editor.create(); // 如果本地有存储加载本地存储内容


      var html = _this.value || localStorage.editorCache;
      if (html) _this.editor.txt.html(html);
    });
  }
};